import {useSelector} from "react-redux";

/*
Usage:
CheckUserOrganization()
*/

// CHECK USER ORGANIZATION
export function CheckUserOrganization(orgData) {
    let hasOrg = false;
    if (orgData !== "" && orgData !== null && orgData.orgId && orgData.orgId !== "") {
        hasOrg = true;
    }
    return hasOrg;
}